import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-final-form';
import { useHistory, useLocation } from 'react-router';
import queryString from 'query-string';
//api
import api from '@/api';
// components
import FormSection from '@/components/forms/FormSection';
import {
  LongDashIcon,
  SsoBriefIcon,
  ForwardArrow,
  ArrowLeft,
} from '@/components/landing-page-templates/ConfigLandingPage/LandingPageIcons';
import FacebookLoginButton from '@/components/landing-page-templates/ConfigLandingPage/ConfigAuthComponents/SocialLoginSection/FacebookLoginButton';
import LinkedInLoginButton from '@/components/landing-page-templates/ConfigLandingPage/ConfigAuthComponents/SocialLoginSection/LinkedInLoginButton';
import GoogleLoginButton from '@/components/landing-page-templates/ConfigLandingPage/ConfigAuthComponents/SocialLoginSection/GoogleLoginButton';
import TermsAndConditions from '@/components/landing-page-templates/ConfigLandingPage/DisplayMessageComponents/TermsAndConditions';
import OtpForm from '@/components/landing-page-templates/ConfigLandingPage/ConfigAuthComponents/AuthForms/OtpForm';
// images
//utils + hooks
import { debounce } from 'lodash';
import { isValidEmail } from '@/utils/jsHelpers/validator';
import { _isUndefined, _isEmpty as _isEmptyObj } from '@/utils/jsHelpers/obj';
import { _isEmpty } from '@/utils/jsHelpers/array';
import { redirectToSsoLoginPage } from '@/components/landing-page-templates/ConfigLandingPage/utils';
//types
import {
  IEventCheckinType,
  ILoginType,
} from '@/components/landing-page-templates/ConfigLandingPage/types';
import { IAccountRegistrationEnum } from '@/models/account/types';
// config styles + types
import styles from './styles.module.scss';
import { FORM_FIELDS } from './config';
import LoginWithTicketCode from '../LoginWithTicketCode';
import Button from '@/components/ui/buttons/Button';
import classnames from 'classnames';
import { showOTPFormIfMagicLinkEnabled } from './utils';
import { isRegistrationInActive } from '@/utils/helpers';

const InitialEmailForm = ({
  event,
  landingPageObject,
  buttonStyle,
  email,
  setEmail,
  updateLastLoginMethod,
  updateEmailExists,
  setLoginMethod,
  setNotificationMode,
  isLogin = false,
  isEventLive,
  setShowLoginOption,
  setCheckRegistrationExists,
  isSpeakerPage,
  otpInitiated,
  setOtpInitiated,
  setShowLogoutPromptForNotCheckinUser,
  isSponsorLandingPage = false,
  isLoginFlowOnly = false,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { eventId, organizationId } = event;

  // Get the GET parameter for the redirect reference
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  // NOTE - this GET parameter is called 'ref'
  const { ref } = searchParams;

  const [toggleEmailSignin, setToggleEmailSignin] = useState<boolean>(false);

  const [magicLinkSent, setMagicLinkSent] = useState(false);
  const isRegistrationsEnabled =
    event.type === 'SERIES' || event?.isRegistrationsEnabled;

  const {
    eventEntryType,
    attendeeAuthType,
    speakerAuthType,
    guestModeEnabled,
    formFontColour,
    formBgColour,
    magicLinkEnabled,
  } = landingPageObject;

  const showLoginWithTicketCode = isSpeakerPage
    ? speakerAuthType.includes('TICKET_CODE')
    : attendeeAuthType.includes('TICKET_CODE');

  const showEmailLogin: boolean = isSpeakerPage
    ? speakerAuthType.includes('EMAIL')
    : attendeeAuthType.includes('EMAIL');
  const showOtpLogin: boolean = isSpeakerPage
    ? speakerAuthType.includes('EMAIL_OTP')
    : attendeeAuthType.includes('EMAIL_OTP');
  // const socialLogin: boolean = isSpeakerPage ? speakerAuthType.includes('SOCIAL_LOGIN') : attendeeAuthType.includes('SOCIAL_LOGIN');
  const ssoLogin: boolean = isSpeakerPage
    ? speakerAuthType.includes('SSO')
    : attendeeAuthType.includes('SSO');

  const googleLogin: boolean = isSpeakerPage
    ? speakerAuthType.includes('GOOGLE')
    : attendeeAuthType.includes('GOOGLE');
  const facebookLogin: boolean = isSpeakerPage
    ? speakerAuthType.includes('FACEBOOK')
    : attendeeAuthType.includes('FACEBOOK');
  const linkedinLogin: boolean = isSpeakerPage
    ? speakerAuthType.includes('LINKEDIN')
    : attendeeAuthType.includes('LINKEDIN');
  const socialLogin: boolean = googleLogin || facebookLogin || linkedinLogin;
  // const guestLogin: boolean = guestModeEnabled && eventEntryType !== IEventCheckinType.INVITE_ONLY;

  const onlyEmailLogin: boolean =
    showEmailLogin && !showOtpLogin && !socialLogin && !ssoLogin;
  const onlyOtpLogin: boolean =
    !showEmailLogin && showOtpLogin && !socialLogin && !ssoLogin;
  const onlySocialLogin: boolean = false; //!showEmailLogin && !showOtpLogin && socialLogin && !ssoLogin;
  const onlySsoLogin: boolean =
    !showEmailLogin && !showOtpLogin && !socialLogin && ssoLogin;

  const hideDividingLine = !socialLogin && !ssoLogin && !showEmailLogin;

  // Enable guest mode only for these conditions: 1) guest mode enabled from the
  //  the organizer side 2) not an invite only event 3) event is live and 4) it
  //  is the attendee page (not the speaker page)
  // const isGuestModeEnabled: boolean =
  //   guestModeEnabled &&
  //   eventEntryType !== IEventCheckinType.INVITE_ONLY &&
  //   !isSpeakerPage &&
  //   isEventLive;
  // Show the Guest Login button
  // const showGuestLoginButton: boolean =
  //   isGuestModeEnabled &&
  //   // Non-ticketed event
  //   (!eventHasTicketTypes ||
  //     // Ticketed event with free ticket selected
  //     (eventHasTicketTypes && freeTicketSelected) ||
  //     // Ticketed event with no ticket selected
  //     !selectedTicketTypeId);

  // useEffect(() => {
  //   if (onlyOtpLogin) {
  //     otpLogin();
  //   }
  // }, [onlyOtpLogin]);

  // useEffect(() => {
  //   if (onlySsoLogin) {
  //     handleSsoOnClick();
  //   }
  // }, [onlySsoLogin]);

  const updateLoginMethod = (loginType: ILoginType) => {
    setLoginMethod(loginType);
    dispatch({
      type: 'account/setSelectedLoginMethod',
      payload: { selectedLoginMethod: loginType },
    });
  };

  const handleOnChange = debounce(target => {
    // Check if email has changed from the state and if email is valid
    if (target.value !== email && isValidEmail(target.value)) {
      setEmail(target.value);
    }
  }, 300);

  const initialValues = {
    emailInput: email,
  };

  const getLastLoginMethod = async (trimmedEmail: string) => {
    // Get the last login method like "FACEBOOK" so we can direct the user to use that login method
    const {
      data: loginMethodResponse,
    } = await api.account.checkAccountLoginType(trimmedEmail);
    if (loginMethodResponse) {
      updateLastLoginMethod(loginMethodResponse);
    }
  };

  const checkInviteOnlyEventAccess = async (trimmedEmail: string) => {
    try {
      const {
        data: inviteOnlyAccess,
      } = await api.eventRole.checkInviteOnlyAccess(trimmedEmail, eventId);
      // setLoading(false);
      // NOTE - the backend API returns a 'boolean' and the frontend treats it as a boolean but adding a check for the string type just in case
      if (inviteOnlyAccess === 'false' || inviteOnlyAccess === false) {
        dispatch({
          type: 'account/setRegistrationStep',
          payload: {
            registrationStep: IAccountRegistrationEnum.NO_ACCESS,
          },
        });
      }
      // The response was not false, so they have access to the invite only event
      else {
        const response = await api.account.checkExistsByEmail(trimmedEmail);
        const accountExists: boolean =
          response.data === 'true' || response.data === true;
        // If the account exists, get last login method

        if (!accountExists) {
          updateEmailExists(false);
        } else {
          // NOTE - we are assuming the account exists in the database because they have access to the invite only event
          updateEmailExists(true);
          // Account exists if they have access to the invite only event, get
          // their last login method
          getLastLoginMethod(trimmedEmail);
        }
      }
    } catch (error) {
      dispatch({
        type: 'global/addDangerToast',
        payload: { description: 'Something went wrong, please try again...' },
      });
    }
  };

  const checkAccountExists = async (trimmedEmail: string) => {
    // Check if this email exists
    const { data } = await api.account.checkExistsByEmail_v2(trimmedEmail);
    // setLoading(false);
    // NOTE - the backend API returns a 'boolean' and the frontend treats it as a boolean but adding a check for the string type just in case
    const accountExists: boolean = data === 'true' || data === true;
    updateEmailExists(accountExists);

    if (accountExists) {
      api.eventRole.checkInviteOnlyAccess(trimmedEmail, eventId).then(res => {
        if (res.data === 'false' || res.data === false) {
          if (!isSpeakerPage) {
            const registrationRequestObject = {
              eventId,
              email: trimmedEmail,
            };
            api.registration
              .getRegistrationByEmail(registrationRequestObject)
              .then(res => {})
              .catch(err => {
                if (
                  err?.response?.status === 406 &&
                  err?.response?.data.message === 'NOT_ACCEPTABLE'
                ) {
                  setCheckRegistrationExists(false);
                  return;
                }
              });
          } else {
            setShowLogoutPromptForNotCheckinUser(true);
            return;
          }
        }
      });
    } else {
      if (isSpeakerPage) {
        setShowLogoutPromptForNotCheckinUser(true);
        return;
      }
    }

    // If the account exists, get last login method
    if (accountExists) {
      getLastLoginMethod(trimmedEmail);
    }
  };

  const handleFlexEventLogin = async (trimmedEmail: string) => {
    const registrationRequestObject = {
      eventId,
      email: trimmedEmail,
    };
    try {
      const {
        data: registrationDetails,
      } = await api.registration.getRegistrationByEmail(
        registrationRequestObject,
      );
      if (registrationDetails) {
        // Check if this email exists
        const { data } = await api.account.checkExistsByEmail_v2(trimmedEmail);
        // setLoading(false);
        // NOTE - the backend API returns a 'boolean' and the frontend treats it as a boolean but adding a check for the string type just in case
        const accountExists: boolean = data === 'true' || data === true;
        if (accountExists) {
          updateEmailExists(accountExists);
        }

        setLoginMethod(ILoginType.EMAIL);
        dispatch({
          type: 'account/setSelectedLoginMethod',
          payload: { selectedLoginMethod: ILoginType.EMAIL },
        });
        // Store the email which they entered in the form
        setEmail(trimmedEmail);
        // Set the registration step to "ENTER_PASSWORD"
        dispatch({
          type: 'account/setRegistrationStep',
          payload: {
            registrationStep: IAccountRegistrationEnum.ENTER_PASSWORD,
          },
        });
      } else {
        return { emailInput: 'This email is deactivated from this event' };
      }
    } catch (err) {
      if (err?.response?.status !== 200) {
        return { emailInput: err?.response?.data?.description };
      }
    }
  };

  const handleFormSubmit = ({ emailInput }) => {
    // Trim whitespace from email
    const trimmedEmail: string = emailInput.trim();
    if ((isLoginFlowOnly || !isRegistrationsEnabled) && !isSpeakerPage) {
      return handleFlexEventLogin(trimmedEmail);
    }

    // Update the current auth method as email
    setLoginMethod(ILoginType.EMAIL);
    dispatch({
      type: 'account/setSelectedLoginMethod',
      payload: { selectedLoginMethod: ILoginType.EMAIL },
    });

    // Store the email which they entered in the form
    setEmail(trimmedEmail);
    // Set the registration step to "ENTER_PASSWORD"
    dispatch({
      type: 'account/setRegistrationStep',
      payload: { registrationStep: IAccountRegistrationEnum.ENTER_PASSWORD },
    });

    if (eventEntryType === IEventCheckinType.INVITE_ONLY) {
      checkInviteOnlyEventAccess(trimmedEmail);
    } else {
      // Check if this email exists and get last login method
      checkAccountExists(trimmedEmail);
    }
  };

  const handleFormMagicLinkSubmit = async ({ emailInput }) => {
    // Trim whitespace from email
    const trimmedEmail: string = emailInput.trim();

    const registrationRequestObject = {
      eventId,
      email: trimmedEmail,
    };
    try {
      const { data: isValid } = await api.registration.resendMagicLink(
        registrationRequestObject,
      );
      if (isValid) {
        setMagicLinkSent(true);
      } else {
        return { emailInput: 'This email is deactivated from this event' };
      }
    } catch (err) {
      if (err?.response?.status !== 200) {
        const errMessage = err?.response?.data?.message;
        const errDesc = err?.response?.data?.description;
        if (isRegistrationInActive(errMessage)) {
          dispatch({
            type: 'global/addDangerToast',
            payload: { description: errDesc },
          });
          return;
        }
        if (isLoginFlowOnly) {
          return { emailInput: errDesc };
        }
        if (errMessage === 'REGISTRATION_NOT_FOUND') {
          setCheckRegistrationExists(false);
        }
      }
    }
  };

  const otpLogin = () => {
    setLoginMethod(ILoginType.EMAIL_OTP);
    dispatch({
      type: 'account/setSelectedLoginMethod',
      payload: { selectedLoginMethod: ILoginType.EMAIL_OTP },
    });
    dispatch({
      type: 'account/setRegistrationStep',
      payload: {
        registrationStep: IAccountRegistrationEnum.EMAIL_OTP_LOGIN,
      },
    });
  };

  const handleSsoOnClick = () => {
    // App level SSO Login
    if (!eventId) {
      // Get the 'ref' GET parameter and push it with the URL
      history.push(`/a/sso${ref ? `?ref=${ref}` : ''}`);
    }
    // PRODUCTION- DSG October 2021 event
    //  https://app.zuddl.com/p/a/event/acecf84e-3d6c-4575-a1df-8caa29398135
    else if (
      eventId === 'acecf84e-3d6c-4575-a1df-8caa29398135' ||
      eventId === '3d9ad6f7-663b-453d-b045-ad004b9d7636'
    ) {
      dispatch({
        type: 'account/ssoLogin',
        payload: {
          ssoDomain: 'dcsg.com',
          redirectRef: location.pathname,
          eventId: eventId,
        },
      });
    } else if (
      eventEntryType !== IEventCheckinType.INVITE_ONLY &&
      !isSpeakerPage
    ) {
      redirectToSsoLoginPage(eventId, organizationId, dispatch);
    } else {
      // Update the current auth method as SSO; For invite only case,
      // we collect the email to check if its invited before sso login
      setLoginMethod(ILoginType.SSO);
    }
  };

  // ========== Guest Auth button ==========
  const setGuestAuthState = () => {
    // Set the login type as guest
    setLoginMethod(ILoginType.GUEST);
    // Take user to the final guest auth form
    dispatch({
      type: 'account/setRegistrationStep',
      payload: { registrationStep: IAccountRegistrationEnum.GUEST_LOGIN },
    });
  };

  const [showLoginWithOTP, setShowLoginWithOTP] = useState(false);
  const headerText = useMemo(() => {
    if (showLoginWithTicketCode && !showLoginWithOTP) {
      return 'Log in with your ticket code';
    }
    if (!showOtpLogin && (!magicLinkEnabled || isSpeakerPage)) {
      return 'Login';
    }
    return 'Log in with your email';
  }, [
    showLoginWithTicketCode,
    showOtpLogin,
    magicLinkEnabled,
    isSpeakerPage,
    showLoginWithOTP,
  ]);

  const handleLoginWithEmailClick = () => {
    setShowLoginWithOTP(true);
  };

  const handleLoginWithEmailBack = () => {
    if (isLoginFlowOnly || showLoginWithTicketCode) {
      setShowLoginWithOTP(false);
      return;
    }
    setShowLoginOption(false);
  };

  const showLoginWithTicketCodeView =
    showLoginWithTicketCode && !showLoginWithOTP && !toggleEmailSignin;

  const showResendMagicLinkView =
    magicLinkEnabled &&
    !isSpeakerPage &&
    !magicLinkSent &&
    !showOTPFormIfMagicLinkEnabled(eventId);

  const showOtpLoginView =
    showOtpLogin &&
    (!magicLinkEnabled ||
      isSpeakerPage ||
      showOTPFormIfMagicLinkEnabled(eventId));

  const getBottomView = () => {
    const showBottomView = showLoginWithTicketCode
      ? showLoginWithTicketCodeView
      : !otpInitiated && !magicLinkSent;

    if (showBottomView) {
      return (
        <>
          {((magicLinkEnabled && !isSpeakerPage) || showOtpLogin) &&
            !hideDividingLine && (
              <div className={styles.continueWith}>
                <LongDashIcon />
                <LongDashIcon />
                <LongDashIcon />
                <LongDashIcon /> or <LongDashIcon />
                <LongDashIcon />
                <LongDashIcon />
                <LongDashIcon />
              </div>
            )}

          {socialLogin && (
            <div className={styles.socialIconBtnContainer}>
              {facebookLogin && (
                <FacebookLoginButton
                  updateLoginMethod={setLoginMethod}
                  updateLastLoginMethod={updateLastLoginMethod}
                  existingLoginMethod={false}
                  isAttendeeRegistration={!isSpeakerPage}
                  setCheckRegistrationExists={setCheckRegistrationExists}
                  isSponsorLandingPage={isSponsorLandingPage}
                  organizationId={event?.organizationId}
                />
              )}
              {googleLogin && (
                <GoogleLoginButton
                  updateLoginMethod={setLoginMethod}
                  updateLastLoginMethod={updateLastLoginMethod}
                  existingLoginMethod={false}
                  setNotificationMode={setNotificationMode}
                  isAttendeeRegistration={!isSpeakerPage}
                  setCheckRegistrationExists={setCheckRegistrationExists}
                  organizationId={event?.organizationId}
                />
              )}
              {linkedinLogin && (
                <LinkedInLoginButton
                  updateLoginMethod={setLoginMethod}
                  updateLastLoginMethod={updateLastLoginMethod}
                  existingLoginMethod={false}
                  isAttendeeRegistration={!isSpeakerPage}
                  setCheckRegistrationExists={setCheckRegistrationExists}
                  organizationId={event?.organizationId}
                />
              )}
            </div>
          )}
          {ssoLogin && (
            <div className={styles.ssoIconBtnContainer}>
              <div
                className={styles.socialIconSSO}
                onClick={() => handleSsoOnClick()}
              >
                <SsoBriefIcon />{' '}
                <span className={styles.socialIconSSOText}>SSO</span>
              </div>
            </div>
          )}

          {showEmailLogin && (
            <div
              className={styles.usePasswordLine}
              onClick={() => setToggleEmailSignin(true)}
            >
              Log in with Password
            </div>
          )}

          {showLoginWithTicketCode && (
            <Button
              label="Log in with email"
              type="button"
              className={styles.logInWithEmail}
              onClick={handleLoginWithEmailClick}
              style={{
                backgroundColor: buttonStyle?.backgroundColor,
                color: buttonStyle?.color,
              }}
            />
          )}

          {/* {showGuestLoginButton &&
          <div className={styles.guestOption} onClick={() => setGuestAuthState()}>
            Guest log in
          </div>
        } */}

          {/* <TermsAndConditions /> */}
        </>
      );
    }
    return null;
  };

  if (showLoginWithTicketCodeView) {
    return (
      <div
        className={classnames(styles.InitialFormContainer, {
          [styles.removeBorder]: isLoginFlowOnly,
        })}
      >
        <div className={styles.mainHeading}>
          {!isLoginFlowOnly && (
            <span
              className={styles.registrationArrow}
              onClick={() => {
                setShowLoginOption(false);
                setToggleEmailSignin(false);
              }}
            >
              <ArrowLeft />
            </span>
          )}
          <span className={styles.center}>{headerText}</span>
        </div>
        <LoginWithTicketCode
          buttonStyle={buttonStyle}
          isSpeakerPage={isSpeakerPage}
          isSponsorLandingPage={isSponsorLandingPage}
        />
        {getBottomView()}
      </div>
    );
  }

  if (toggleEmailSignin || onlyEmailLogin) {
    return (
      <div
        className={classnames(styles.InitialFormContainer, {
          [styles.removeBorder]: isLoginFlowOnly,
        })}
      >
        <div className={styles.mainHeading}>
          <span
            className={styles.registrationArrow}
            onClick={() => {
              setShowLoginOption(showLoginWithTicketCode);
              setToggleEmailSignin(false);
            }}
          >
            <ArrowLeft />
          </span>
          {isLogin ? 'Enter the Event' : 'Register for the Event'}
        </div>
        <Form
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          render={({ handleSubmit, submitting }) => (
            <form
              onSubmit={handleSubmit}
              onChange={e => handleOnChange(e.target)}
            >
              <FormSection
                formData={FORM_FIELDS}
                isSponsorLandingPage={isSponsorLandingPage}
              />
              <div className={styles.registerButton}>
                <button
                  type="submit"
                  onSubmit={handleSubmit}
                  onClick={handleSubmit}
                  onKeyPress={handleSubmit}
                  style={buttonStyle}
                  className={styles.submitButton}
                >
                  <ForwardArrow color={formFontColour} />
                  <p className={styles.buttonText}>
                    {isLogin ? 'Sign In' : 'Register Now'}
                  </p>
                </button>
              </div>
            </form>
          )}
        />
        {/* <TermsAndConditions /> */}
      </div>
    );
  }

  if (onlySocialLogin) {
    return (
      <div
        className={classnames(styles.InitialFormContainer, {
          [styles.removeBorder]: isLoginFlowOnly,
        })}
      >
        <div className={styles.mainHeading}>
          {isLogin ? 'Enter the Event' : 'Register for the Event'}
        </div>
        <GoogleLoginButton
          updateLoginMethod={setLoginMethod}
          updateLastLoginMethod={updateLastLoginMethod}
          existingLoginMethod={true}
          setNotificationMode={setNotificationMode}
          signInButton={true}
          isAttendeeRegistration={!isSpeakerPage}
          setCheckRegistrationExists={setCheckRegistrationExists}
          organizationId={event?.organizationId}
        />
        <LinkedInLoginButton
          updateLoginMethod={setLoginMethod}
          updateLastLoginMethod={updateLastLoginMethod}
          existingLoginMethod={true}
          signInButton={true}
          isAttendeeRegistration={!isSpeakerPage}
          setCheckRegistrationExists={setCheckRegistrationExists}
          organizationId={event?.organizationId}
        />
        <FacebookLoginButton
          updateLoginMethod={setLoginMethod}
          updateLastLoginMethod={updateLastLoginMethod}
          existingLoginMethod={true}
          signInButton={true}
          isAttendeeRegistration={!isSpeakerPage}
          setCheckRegistrationExists={setCheckRegistrationExists}
          organizationId={event?.organizationId}
        />
        <TermsAndConditions />
      </div>
    );
  }

  return (
    <div
      className={classnames(styles.InitialFormContainer, {
        [styles.removeBorder]: isLoginFlowOnly,
      })}
    >
      {!isSpeakerPage && (
        <div className={styles.mainHeading}>
          {(showLoginWithTicketCode || !isLoginFlowOnly) && (
            <span
              className={styles.registrationArrow}
              onClick={handleLoginWithEmailBack}
            >
              <ArrowLeft />
            </span>
          )}
          <span className={styles.center}>
            {(!otpInitiated || isLoginFlowOnly) && headerText}
          </span>
        </div>
      )}
      {isSpeakerPage && (
        <div className={styles.mainHeading_speaker}>
          {!otpInitiated && headerText}
        </div>
      )}

      {showResendMagicLinkView && (
        <div>
          <Form
            onSubmit={handleFormMagicLinkSubmit}
            initialValues={initialValues}
            render={({ handleSubmit, submitting }) => (
              <form
                onSubmit={handleSubmit}
                onChange={e => handleOnChange(e.target)}
              >
                <FormSection
                  formData={FORM_FIELDS}
                  isSponsorLandingPage={isSponsorLandingPage}
                />
                <div className={styles.registerButton}>
                  <button
                    type="submit"
                    onSubmit={handleSubmit}
                    onClick={handleSubmit}
                    onKeyPress={handleSubmit}
                    style={buttonStyle}
                    className={styles.submitButton}
                  >
                    <p className={styles.buttonText}>{'Submit'}</p>
                  </button>
                </div>
              </form>
            )}
          />
        </div>
      )}

      {magicLinkSent && (
        <div className={styles.magicLinkSentText}>
          Success! <br /> Check your email for the event invite
        </div>
      )}

      {showOtpLoginView && (
        <OtpForm
          buttonBackgroundColor={formBgColour}
          updateLoginMethod={updateLoginMethod}
          _email={email}
          setEmail={setEmail}
          setNotificationMode={setNotificationMode}
          isOtpLogin={false}
          buttonStyle={buttonStyle}
          setOtpInitiated={setOtpInitiated}
          setCheckRegistrationExists={setCheckRegistrationExists}
          isSpeakerPage={isSpeakerPage}
          setShowLogoutPromptForNotCheckinUser={
            setShowLogoutPromptForNotCheckinUser
          }
          isSponsorLandingPage={isSponsorLandingPage}
          isLoginFlowOnly={isLoginFlowOnly}
        />
      )}
      {getBottomView()}
    </div>
  );
};

export default InitialEmailForm;
